import React from 'react';
import { ApolloProvider } from '@apollo/client';
import { IntlProvider } from 'react-intl';
import { Provider } from 'react-redux';
import { SnackbarProvider } from 'notistack';
import client from '../../../lib/apolloClient';
import translations from '../../../lib/i18n/translations.json';
import configureStore from '../../../store/findBobPublicStore';
import SuccessionThemeProvider from '../SuccessionThemeProvider';
import SuccessionPartialSalesMarketplace from './SuccessionPartialSalesMarketplace';
import SuccessionDrawerWithListener from '../../../containers/Succession/SuccessionDrawerWithListener';

const SuccessionPartialSalesContainer = ({
  partialSales,
  user,
  company,
  partialSaleQuestions,
  features,
  pageTitle,
  isMyPartialSales
}, railsContext) => {
  // Check if modernization feature is enabled
  const isModernizationEnabled = features?.includes('findbob_modernization');

  // Configure Redux store with only the props that match reducer keys
  const store = configureStore({
    user,
    company
  });

  window.locale = (railsContext && railsContext.i18nLocale) || window.locale || 'en';
  const locale = window.locale;
  return (
    <Provider store={store}>
      <ApolloProvider client={client}>
        <IntlProvider locale={locale} messages={translations[locale] || translations.en}>
        <SnackbarProvider maxSnack={3}>
          <SuccessionThemeProvider company={company} user={user}>
            <SuccessionPartialSalesMarketplace 
              partialSales={partialSales}
              user={user}
              company={company}
              partialSaleQuestions={partialSaleQuestions}
              features={features}
              isModernizationEnabled={isModernizationEnabled}
              pageTitle={pageTitle}
              isMyPartialSales={isMyPartialSales}
            />
            <SuccessionDrawerWithListener />
          </SuccessionThemeProvider>
        </SnackbarProvider>
        </IntlProvider>
      </ApolloProvider>
    </Provider>
  );
};

export default SuccessionPartialSalesContainer;